const CHUNK_LOAD_ERROR_PATTERN =
  /Loading chunk [\d]+ failed|ChunkLoadError|Failed to fetch dynamically imported module/i;

export function registerChunkLoadErrorHandler() {
  const reloadOnChunkError = (message: string) => {
    if (!CHUNK_LOAD_ERROR_PATTERN.test(message)) return;
    window.location.reload();
  };

  window.addEventListener("error", (event) => {
    if (event.message) reloadOnChunkError(event.message);
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message =
      typeof reason === "string"
        ? reason
        : reason?.message || reason?.toString?.() || "";

    reloadOnChunkError(message);
  });
}
